export default "__VITE_ASSET__BWoZ3IG2__"